import React from 'react';
import { RouterProvider } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from 'react-hot-toast';
import { Loader2 } from 'lucide-react';
import { CookiesProvider } from 'react-cookie';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

import { TooltipProvider } from './components/ui/tooltip';
import { router } from 'routes/router';

import './config/i18n';
import './style.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false,
    },
  },
});

export default function App() {
  return (
    <React.Suspense fallback={<SuspenseFallback />}>
      <QueryClientProvider client={queryClient}>
        <TooltipProvider>
          <CookiesProvider defaultSetOptions={{ path: '/' }}>
            <RouterProvider router={router} />
          </CookiesProvider>
        </TooltipProvider>
        <Toaster containerStyle={{ zIndex: 99999 }} />
        <ReactQueryDevtools initialIsOpen={false} />
      </QueryClientProvider>
    </React.Suspense>
  );
}

function SuspenseFallback() {
  return (
    <div className='flex items-center justify-center w-screen h-screen'>
      <Loader2
        role='progressbar'
        className='w-10 h-10 stroke-1 animate-spin text-primary'
      />
    </div>
  );
}
